import { Box, Table, Tbody, Th, Thead, Tr } from "@chakra-ui/react";
import { ReachoutLogsTableRow } from "./ReachoutLogsTableRow";
import Reachout from "../../services/Reachout";
import { useContext, useEffect, useState } from "react";
import { appContext } from "../../Context/AppContext";

export const ReachoutLogsTable = () => {
  const { pageId } = useContext(appContext);
  const [data, setData] = useState([]);

  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalReachouts, setTotalReachouts] = useState(0);
  const [page, setPage] = useState(1);

  const fetchData = () => {
    Reachout.getReachoutNotifications(page, pageSize)
      .then((res) => {
        setData(res.data.data);
        setTotalReachouts(res.data.total);
        setTotalPages(res.data.data.totalPages);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchData();
  }, [pageId, page]);

  useEffect(() => {
    setPage(1);
  }, [pageId]);

  return (
    <Box w="100%">
      <Box w="100%" bg="white" overflowX="scroll">
        <Table variant="simple" border="1px solid gray" layout="auto" size="sm">
          <Thead bg="#70afaf">
            <Tr>
              <Th px={2} minWidth="50px">
                Edit
              </Th>
              <Th px={2} minWidth="150px">
                Template Id
              </Th>
              <Th px={2} minWidth="150px">
                Scheduled Date
              </Th>
              <Th px={2} minWidth="150px">
                Scheduled Time
              </Th>
              <Th px={2} minWidth="100px">
                Status
              </Th>
              <Th px={2} minWidth="120px">
                Type
              </Th>
              <Th px={2} minWidth="150px">
                Campaign Id
              </Th>
              <Th px={2} minWidth="120px">
                Count
              </Th>
              <Th px={2} minWidth="150px">
                Status
              </Th>
              <Th px={2} minWidth="150px">
                Source
              </Th>
              <Th px={2} minWidth="150px">
                Languages
              </Th>
              <Th px={2} minWidth="150px">
                Gender
              </Th>
              <Th px={2} minWidth="100px">
                Age Group
              </Th>
              <Th px={2} minWidth="100px">
                Budget
              </Th>
              <Th px={2} minWidth="150px">
                System Age
              </Th>
              <Th px={2} minWidth="50px">
                Delete
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.map((el: any) => (
              <ReachoutLogsTableRow
                el={el}
                // page={page}
                func={fetchData}
                pageId={pageId}
              />
            ))}
          </Tbody>
        </Table>
      </Box>
      <div className="flex row m-0 pagination">
        <div className="col-sm-6 p-lg-0">
          <p style={{ fontSize: "16px", paddingLeft: "12px" }}>
            Showing {(page - 1) * pageSize + 1} to{" "}
            {page * pageSize > totalReachouts
              ? totalReachouts
              : page * pageSize}{" "}
            of {totalReachouts} entries
          </p>
        </div>
        <div className="col-sm-6 p-lg-0 text-right">
          <div className="btn-group" role="group">
            <button
              type="button"
              className={
                page === 1 ? "btn action-btn disabledButton " : "btn action-btn"
              }
              onClick={() => setPage(page - 1)}
              disabled={page === 1 ? true : false}
            >
              {"<< Previous"}
            </button>
            <button type="button" className="btn action-btn selected">
              {page}
            </button>
            <button
              type="button"
              className={
                page === totalPages || totalPages === 0
                  ? "btn action-btn disabledButton "
                  : "btn action-btn"
              }
              onClick={() => setPage(page + 1)}
              disabled={page === totalPages || totalPages === 0 ? true : false}
            >
              {"Next >>"}
            </button>
          </div>
        </div>
      </div>
    </Box>
  );
};
